import { PRIMARY_COLOR } from "config/constants";
import PulseLoader from "react-spinners/PulseLoader";

const LoadingIndicator = ({ color = PRIMARY_COLOR, inline = false, size = 10 }) => {
  return (
    inline ? (
      <div className="w-100 h-100 d-flex justify-content-center align-items-center">
        <PulseLoader
          color={color}
          loading={true}
          size={size}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    ) : (
      <div className="w-100 h-100 d-flex justify-content-center align-items-center position-fixed"
        style={{ top: 0, left: 0, height: "100vh" }}>
        <PulseLoader
          color={color}
          loading={true}
          size={size}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    )
  )
}

export default LoadingIndicator;